import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { formatISODate } from '../util/dateHelpers';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    height: '100%',
  },
  header: {
    fontSize: theme.spacing(2.5),
    color: theme.palette.primary.main,
  },
  newsItem: {
    marginTop: theme.spacing(2),
  },
  newsItemHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: theme.spacing(2.5),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  date: {
    fontSize: theme.spacing(1.25),
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(3),
  },
  content: {
    fontSize: theme.spacing(1.75),
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderBottom: '2px solid lightgray',
    width: '100%',
  },
}));

const newsItems = [
  {
    date: '2020-08-28T18:00:00Z',
    title: 'Application Update - 1.0.0.30495',
    content:
      'Your application was recently upgraded to 1.0.0.30495. This build includes new features as well as bug fixes. Click to learn more.',
  },
  {
    date: '2020-08-28T18:00:00Z',
    title: 'Security Update - CVE-0192415',
    content:
      'Your application was recently patched to fix CVE-0192415. Click to learn more about this vulnerability.',
  },
  {
    date: '2020-08-28T18:00:00Z',
    title: 'Service Outage',
    content:
      'On 2020-08-28T18:00:00Z our systems detected a momentary service outage that affected a small set of customers on the west coast of the United States.\nThis outage lasted for less than 10 minutes. Click to learn more.',
  },
];

const News = () => {
  const classes = useStyles();

  const replaceDate = (text) => {
    return text.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g, (x) => {
      return formatISODate(x, 'at');
    });
  };

  return (
    <Paper className={classes.paper} square>
      <Typography className={classes.header}>PremiSys News</Typography>
      {newsItems.map((item, index) => (
        // TODO: find out if there is anything unique about timeline events that can be used as a key other than combining date & title
        <div className={classes.newsItem} key={item.date + item.title}>
          <div className={classes.newsItemHeader}>
            <Typography className={classes.title}>{item.title}</Typography>
            <Typography className={classes.date}>{formatISODate(item.date)}</Typography>
          </div>
          <Typography className={classes.content} style={{ whiteSpace: 'pre-line' }}>
            {replaceDate(item.content)}
          </Typography>
          {index < newsItems.length - 1 && <div className={classes.divider} />}
        </div>
      ))}
    </Paper>
  );
};

export default News;
